import { sendToApi } from 'api/client'
import { APICredential } from 'types'

export const ApiKeyClient = {
  create: (intended_use?: string) => {
    return sendToApi<APICredential>('/api-credentials', { method: 'POST', body: { intended_use } })
  },
}
